<!-- 压力曲线图 -->
<template>
  <j-modal
    :title="title"
    :width="1500"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" :tab="$t('数据图形展示')">
          <a-radio-group :value="size" @change="handleTimeChange">
            <a-radio-button value="today">{{ $t('今日') }}</a-radio-button>
            <a-radio-button value="threeday">{{ $t('近三天') }}</a-radio-button>
            <a-radio-button value="week">{{ $t('近一周') }}</a-radio-button>
          </a-radio-group>
          <div id="main1" style="width: 100%;height: 300px;"></div>
          <div id="main2" style="width: 100%;height: 300px;"></div>
        </a-tab-pane>
        <a-tab-pane key="2" :tab="$t('数据列表')">
          <a-table
            ref="table"
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            @change="handleTableChange"
            class="j-table-force-nowrap">
          
            <!-- <span slot="action" slot-scope="text, record">
              <a @click="handleDetail(record)">详情</a>
            </span> -->
          
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </j-modal>
</template>

<script>
  import {tuopuruiSendWayObj} from '@/utils/constants/protocolConstant'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { postAction } from '@/api/manage'
  import * as echarts from 'echarts';
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  export default {
    name: 'PartPwMeterdatarecordListEchartsModal',
    mixins:[JeecgListMixin],
    components: {},
    data () {
      return {
        width:800,
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {},
        url: {
          queryGraphByTime: "/jeecg-charge/wq/partPWHistoryMeterdatarecord/queryGraphByTime",
          list: '/jeecg-charge/wq/partPWHistoryMeterdatarecord/list'
        },
        queryParam:{
          meter: ''
        },
        size: 'today',
      }
    },
    computed: {
      title() {
        return this.$t('压力曲线图')
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'meterid'
          },
          {
            title: this.$t('仪表类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (text) => {
              return filterDictTextByCache('wq_device_type', text);
              //let obj = {1: 'NB压力表',2: 'NB液位计',3: '4G压力表',4: '4G液位计'}
              //return obj[text]?obj[text]: '未知'
            }
          },
          {
            title: this.$t('压力值/液位值'),
            align:"center",
            dataIndex: 'pvalue'
          },
          {
            title: this.$t('温度值'),
            align:"center",
            dataIndex: 'tepvalue'
          },
          {
            title: this.$t('电量 %'),
            align:"center",
            dataIndex: 'battery'
          },
          {
            title: this.$t('信号值'),
            align:"center",
            dataIndex: 'signDb'
          },
          {
            title: this.$t('表端时间'),
            align:"center",
            dataIndex: 'metertime'
          },
          {
            title: this.$t('上报时间'),
            align:"center",
            dataIndex: 'systime'
          },
          {
            title: this.$t('电池状态'),
            align:"center",
            dataIndex: 'batterystatus',
            customRender: (text) => {
              let obj = {0: this.$t('正常'),1: this.$t('欠压')}
              return obj[text]?obj[text]: this.$t('未知')
            }
          },
          {
            title: this.$t('上报方式'),
            align:"center",
            dataIndex: 'metersendway',
            customRender: (text) => {
              let obj = tuopuruiSendWayObj;
              return obj[text]?this.$t(obj[text]): this.$t('未知')
            }
          },
          {
            title: this.$t('传感器状态'),
            align:"center",
            dataIndex: 'sensorstatus',
            customRender: (text) => {
              let obj = {0: this.$t('正常'),1: this.$t('异常')}
              return obj[text]?obj[text]: this.$t('未知')
            }
          },
          {
            title: this.$t('告警状态'),
            align:"center",
            dataIndex: 'datainfo',
            customRender: (text,record) => {
              if(record.warnstatus == 0){
                return this.$t("正常");
              }else{
                return text;
              }
            }
          },
          // {
          //   title: '操作',
          //   dataIndex: 'action',
          //   align:"center",
          //   fixed:"right",
          //   width:147,
          //   scopedSlots: { customRender: 'action' }
          // }
        ]
      }
    },
    created () {
    },
    methods: {
      init(row){
        this.model = row;
        this.visible = true;
        this.queryParam = {
          meterid: row.meterid
        };
        this.getData({meterId:row.meterid,state:1});
        this.loadData({meterId:row.meterid});
      },
      getData(val){
        let params = {
          meterId: val.meterId,
          state: val.state
        }
        postAction(this.url.queryGraphByTime,params).then(res=>{
          if(res.success){
            this.$nextTick(()=>{
              this.setMain1(res.result.timeList,res.result.mpaList,res.result.pvalueTop,res.result.pvalueLow);
              this.setMain2(res.result.timeList,res.result.templateList,res.result.tepvalueTop,res.result.tepvalueLow);
            })
          }
        })
      },
      loadData(val){
        let params = this.getQueryParams();
        params.meterId = val.meterId;
        getAction(this.url.list,params).then((res)=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      setMain1(xData,yData,topY,lowY){
        var chartDom = document.getElementById('main1');
        var myChart = echarts.init(chartDom);
        var option;
        option = {
          grid:{
            bottom: '30%'
          },
          title:{
            text: this.$t('压力曲线图')
          },
          color: '#87d068',
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              animation: false
            }
          },
          xAxis: {
            type: 'category',
            data: xData,
          },
          yAxis: {
            type: 'value',
            name: 'MPa',
            min:0,
            max:topY,
          },
          series: [
            {
              data: yData,
              type: 'line',
              markLine: {
                data: [
                  {yAxis: topY, name: this.$t('上限值'),symbol: 'circle',lineStyle:{color:'red',type:'dashed'},label:{formatter:'{b}:{c}'}},
                  {yAxis: lowY, name: this.$t('下限值'),symbol: 'circle',lineStyle:{color:'orange',type:'dashed'},label:{formatter:'{b}:{c}'}},
                ]
              }
            }
          ]
        };
        if (yData && yData.length > 0) {

        } else {
            option.series[0].markLine.data = ''; // 不显示markLine
        }
        option && myChart.setOption(option);
      },
      setMain2(xData,yData,topY,lowY){
        var chartDom = document.getElementById('main2');
        var myChart = echarts.init(chartDom);
        var option;
        option = {
          grid:{
            bottom: '30%'
          },
          title:{
            text: this.$t('温度曲线图')
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              animation: false
            }
          },
          color: '#87d068',
          xAxis: {
            type: 'category',
            data: xData,
          },
          yAxis: {
            type: 'value',
            name: '℃',
            min:0,
            max:topY,
          },
          series: [
            {
              data: yData,
              type: 'line',
              markLine: {
                data: [
                  {yAxis: topY, name: this.$t('上限值'),symbol: 'circle',lineStyle:{color:'red',type:'dashed'},label:{formatter:'{b}:{c}'}},
                  {yAxis: lowY, name: this.$t('下限值'),symbol: 'circle',lineStyle:{color:'orange',type:'dashed'},label:{formatter:'{b}:{c}'}},
                ]
              }
            }
          ]
        };
        if (yData && yData.length > 0) {
          
        } else {
            option.series[0].markLine.data = ''; // 不显示markLine
        }
        option && myChart.setOption(option);
      },
      handleTimeChange(e){
        this.size = e.target.value;
        if(e.target.value == 'today'){
          this.getData({meterId:this.model.meterid,state:1});
        }else if(e.target.value == 'threeday'){
          this.getData({meterId:this.model.meterid,state:2});
        }else if(e.target.value == 'week'){
          this.getData({meterId:this.model.meterid,state:3});
        }
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>